<!-- 访客受邀页面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <!-- 表格按钮 自定义 -->
            <!-- 上方按钮 -->
            <template slot="menuLeft">
              <el-button
                size="small"
                class="iss-operation-button"
                @click="handelInviteOpt"
              >
                邀约
              </el-button>
            </template>
            <!-- 表格操作按钮 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="780"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="访客邀约记录详情"
    >
      <el-scrollbar style="height: 100%">
        <div class="panel-content">
          <h3 class="info-title">基本信息</h3>
          <div class="content-top">
            <div class="detail-info">
              <div class="info-item">
                <span class="label">邀约来访时间：</span>
                <span class="item-value">{{ form.visitDate }}</span>
              </div>
              <!-- <div class="info-item">
                <span class="label">预约人：</span>
                <span class="item-value">{{ form.appointmentPersonName }}</span>
              </div> -->
              <div class="info-item">
                <span class="label">实际来访时间：</span>
                <span class="item-value">{{
                  form.startTime + "~" + form.endTime
                }}</span>
              </div>
              <div class="info-item">
                <span class="label">接待人：</span>
                <span class="item-value">{{ form.visitorReceiverName }}</span>
              </div>
              <!-- <div class="info-item">
                <span class="label">签入时间：</span>
                <span class="item-value">{{ form.signTime }}</span>
              </div>
              <div class="info-item">
                <span class="label">签入人：</span>
                <span class="item-value">{{ form.signUserName }}</span>
              </div> -->
              <div class="info-item">
                <span class="label">签入时间：</span>
                <span class="item-value">{{ form.signTime }}</span>
              </div>
              <div class="info-item">
                <span class="label">签离时间：</span>
                <span class="item-value">{{ form.leaveTime }}</span>
              </div>

              <div class="info-item">
                <span class="label">签离人：</span>
                <span class="item-value">{{ form.leaveUser }}</span>
              </div>
              <div class="info-item">
                <span class="label">来访事由：</span>
                <span class="item-value">{{ form.visitCause }}</span>
              </div>
              <div class="info-item">
                <span class="label">邀约状态：</span>
                <span class="item-value">{{ statusList[form.status] }}</span>
              </div>
              <div class="info-item">
                <span class="label">签离时间：</span>
                <span class="item-value">{{ form.leaveTime }}</span>
              </div>
            </div>
          </div>
          <h3 class="info-title" style="margin-bottom: 15px">访客信息</h3>
          <el-table
            :data="visitorData"
            :stripe="false"
            size="mini"
            :border="false"
            :highlight-current-row="false"
          >
            <el-table-column
              type="index"
              align="center"
              header-align="center"
              label="序号"
            />
            <el-table-column
              prop="imageUrl"
              label="照片"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="personName"
              label="访客姓名"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="personSex"
              label="性别"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="personPhone"
              label="手机号码"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="idCardNo"
              label="身份证号"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="plateNumber"
              label="车辆号牌"
              width="120"
              align="center"
              show-overflow-tooltip
              header-align="center"
            >
            </el-table-column>
            <template slot="empty">
              <div class="table-empty">
                <img src="@/common/assets/images/empty.svg" />
                <p>{{ $t("base.label.empty") }}</p>
              </div>
            </template>
          </el-table>
        </div>
      </el-scrollbar>

      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>

    <!-- 邀约 -->
    <appPanel
      :width="780"
      class="app-panel"
      :isExpand="showInvitePanel"
      @cancel="handleCloseInvitePanel"
      title="访客邀约"
    >
      <el-scrollbar style="height: 100%">
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="addFormRules"
          label-width="90px"
        >
          <div class="add-invitation__basic">
            <el-row>
              <el-col :span="16">
                <el-form-item label="来访时间" prop="visitDate">
                  <el-date-picker
                    v-model="addForm.visitDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="接待人" prop="visitorReceiver">
                  <el-select
                    v-model="visitorReceiverName"
                    @change="handleRecevierChange"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in receptionistList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.userid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="邀约事由" prop="visitCause">
              <el-input type="area" v-model="addForm.visitCause" />
            </el-form-item>
          </div>
          <!-- <div class="add-invitation__opt">
          <soc-button type="primary" @click="handleAdd">添加</soc-button>
          <soc-button @click="handleDelete">删除</soc-button>
        </div> -->
          <div class="add-invitation__abnormal">
            <el-form-item prop="passPersonList" label="来访人员">
              <!-- <ioc-table
                ref="accessTab"
                :data="personTableData"
                :option="personTableOption"
                @selection-change="handleSelectionChange"
              >
                <template slot="imageUrl" slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="照片"
                    placement="top"
                  >
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="scope.row.imageUrl"
                      :preview-src-list="[scope.row.imageUrl]"
                    >
                    </el-image>
                  </el-tooltip>
                </template>
              </ioc-table> -->
              <el-table
                :data="personTableData"
                :stripe="false"
                size="mini"
                :border="false"
                :highlight-current-row="false"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                  type="index"
                  align="center"
                  header-align="center"
                  label="序号"
                />
                <el-table-column
                  prop="imageUrl"
                  label="照片"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="personName"
                  label="访客姓名"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="personSex"
                  label="性别"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="personPhone"
                  label="手机号码"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="idCardNo"
                  label="身份证号"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                  header-align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="plateNumber"
                  label="车辆号牌"
                  width="120"
                  align="center"
                  show-overflow-tooltip
                  header-align="center"
                >
                </el-table-column>
                <template slot="empty">
                  <div class="table-empty">
                    <img src="@/common/assets/images/empty.svg" />
                    <p>{{ $t("base.label.empty") }}</p>
                  </div>
                </template>
              </el-table>
            </el-form-item>
          </div>
        </el-form>
      </el-scrollbar>

      <div slot="footer">
        <el-button @click="handleCloseInvitePanel">关闭</el-button>
      </div>
    </appPanel>
  </div>
</template>
<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/invitationTable";
import { personTableOption } from "../config/invitePersonTable";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      showInvitePanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      personTableOption: personTableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      personTableData: [],
      visitorReceiverName: "",
      visitDates: [],
      searchParams: {},
      // 新增/修改表格
      subLoading: false,
      title: "",
      showAddOrEditPanel: false,
      // 下拉选项信息
      visitorData: [],
      statusList: {
        1: "待审批",
        2: "已通过",
        3: "已拒绝",
        4: "已签入",
        5: "已签离",
      },
      // 邀约
      receptionistList: [
        { name: "罗灿", userid: "baeb737a04374738858789ab1fa37ad2" },
        { name: "zfq01", userid: "cfb4b23ec61a4d1aa2058e93385559af" },
      ],
      addForm: {
        visitDate: "",
        passPersonList: [],
        startTime: "",
        endTime: "",
        visitorReceiver: "",
        visitorReceiverPhone: "",
        visitCause: "",
      },
      addFormRules: {
        visitDate: [
          {
            required: true,
            message: "请选择来访时间",
            trigger: ["blur", "change"],
          },
        ],
        visitorReceiver: [
          {
            required: true,
            message: "请输入接待人",
            trigger: ["blur", "change"],
          },
        ],
        visitCause: [
          {
            required: true,
            message: "请输入邀约事由",
            trigger: ["blur", "change"],
          },
        ],
        passPersonList: [
          {
            required: true,
            message: "请选择访客",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // TODO获取列表
    getList() {
      const params = {};
      params.pageNumber = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      params.visitType = 1;

      params.startTine = this.searchParams.startTime;
      params.endTime = this.searchParams.endTime;
      params.appointmentStartDate = this.searchParams.appointmentStartDate;
      params.appointmentEndDate = this.searchParams.appointmentEndDate;
      params.visitorsName = this.searchParams.appointmentPersonName;

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.visitorSubscribe, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!res.success) {
          // this.$message.error(res.msgContent);
          this.tableData = [
            {
              appointmentPerson: "bb475069580d44338bf18c3ad528ffc7",
              endTime: "2023-01-30T15:30:00.000+0800",
              invitationTime: "2023-01-30T15:43:19.000+0800",
              leaveTime: "2023-04-06T14:44:35.000+0800",
              leaveUser: "1",
              passPersonnelList: [],
              startTime: "2023-01-30T10:15:00.000+0800",
              status: 2,
              twoDimensionCode:
                "/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJC",
              visitCause: "到访公干",
              visitCode: "20230130154318000001",
              visitDate: "2023-01-30T00:00:00.000+0800",
              actualVisitTime: "2023-01-30T00:00:00.000+0800",
              visitId: 36,
              visitType: 2,
              visitorReceiver: "1",
              visitorReceiverName: "超级管理员",
              visitorsName: "王小磊",
              visitorsNumber: "1",
            },
            {
              appointmentPerson: "1",
              appointmentPersonName: "超级管理员",
              endTime: "2023-04-01T10:59:59.000+0800",
              invitationTime: "2023-03-31T05:55:29.000+0800",
              passPersonnelList: [],
              startTime: "2023-03-30T11:00:00.000+0800",
              status: 3,
              twoDimensionCode:
                "/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJC",
              visitCause: "test",
              visitCode: "20230331185528000001",
              visitDate: "2023-01-30T00:00:00.000+0800",
              actualVisitTime: "2023-01-30T00:00:00.000+0800",
              visitId: 71,
              visitType: 1,
              visitorReceiver: "104d35e92e8c47798f80931ab12cea44",
              visitorReceiverName: "王和兵",
              visitorsName: "吴吴",
              visitorsNumber: "1",
            },
          ];
          this.page.total = 2;
          return;
        }
        this.tableData = res.data ? Object.freeze([...res.data.list]) : [];
        this.page.total = res.data ? res.data.total : 0;
      });
    },

    handleView(row, index) {
      this.showPanel = true;
      this.form = row;
      this.$fetch(api.showVisit, { visitId: row.visitId, visitType: 1 }).then(
        (res) => {
          if (!res.success) {
            // this.$message.error(res.msgContent);
            // 失败
            this.showPanel = true;
            this.form = {
              appointmentPerson: "bb475069580d44338bf18c3ad528ffc7",
              endTime: "2023-01-30T15:30:00.000+0800",
              leaveTime: "2023-04-06T14:44:35.000+0800",
              leaveUser: "1",
              leaveUserName: "超级管理员",
              passPersonnelList: [
                {
                  imageUrl: "",
                  personName: "Licy",
                  personSex: "女",
                  personPhone: "18152877150",
                  idCardNo: "430581199010101010",
                  plateNumber: "暂无",
                },
              ],
              passPersonnelSize: 0,
              signTime: "2023-04-06T14:32:23.000+0800",
              signUser: "1",
              signUserName: "超级管理员",
              startTime: "2023-01-30T10:15:00.000+0800",
              status: 2,
              twoDimensionCode:
                "/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJC",
              visitCause: "到访公干",
              visitCode: "20230130154318000001",
              visitDate: "2023-01-30T00:00:00.000+0800",
              visitId: 36,
              visitType: 2,
              visitorReceiver: "1",
              visitorReceiverName: "超级管理员",
              visitorReceiverPhone: "123123",
              visitorsName: "王小磊",
              visitorsNumber: "1",
            };
            // 格式化时间数据
            this.form.visitDate = Dates.format(this.form.visitDate);
            this.form.startTime = Dates.format(this.form.startTime);
            this.form.endTime = Dates.format(this.form.endTime);
            this.form.signTime = Dates.format(this.form.signTime);
            this.form.leaveTime = Dates.format(this.form.leaveTime);
            this.visitorData = this.form.passPersonnelList;
            return;
          }
          // 成功
          this.showPanel = true;
          this.form = res.data;
        }
      );
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      console.log("--searchResult()--param:--", param);
      this.searchParams = param;

      if (param.actualVisitTime && param.actualVisitTime.length > 0) {
        // 来访时间
        this.searchParams.startTine = param.actualVisitTime[0];
        this.searchParams.endTime = param.actualVisitTime[1];
      }
      if (param.visitDate && param.visitDate.length > 0) {
        // 预约时间
        this.searchParams.appointmentStartDate = param.visitDate[0];
        this.searchParams.appointmentEndDate = param.visitDate[1];
      }
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchParams.pageNumber = 1;
      this.searchParams.pageSize = this.page.pageSize;
      this.searchParams.visitType = 1;
      this.searchParams.startTine = "";
      this.searchParams.endTime = "";
      this.searchParams.appointmentStartDate = "";
      this.searchParams.appointmentEndDate = "";
      this.searchParams.visitorsName = "";

      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    // 邀约操作
    handelInviteOpt() {
      this.showInvitePanel = true;
      this.personTableData = [
        {
          imageUrl: "",
          personName: "Licy",
          personSex: "女",
          personPhone: "18152877150",
          idCardNo: "430581199010101010",
          plateNumber: "暂无",
        },
      ];
    },
    // 关闭邀约弹窗
    handleCloseInvitePanel() {
      this.showInvitePanel = false;
    },
    handleSelectionChange(items) {
      console.log("--handleSelectionChange()--items:--", items);
    },
    handleRecevierChange(item, val) {
      this.addForm.visitorReceiverPhone = val.phone;
      this.addForm.visitorReceiver = val.name;
      console.log(item, val, "====change");
    },
  },
};
</script>
<style lang="scss" scoped>
.panel-content {
  .info-title {
    color: #fff;
    border-left-width: 3px;
    border-left-style: solid;
    padding-left: 10px;
    border-left-color: #407aee;
  }
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
